import { render, staticRenderFns } from "./incomeOld.vue?vue&type=template&id=52d8bda7"
import script from "./incomeOld.vue?vue&type=script&lang=js"
export * from "./incomeOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d8bda7')) {
      api.createRecord('52d8bda7', component.options)
    } else {
      api.reload('52d8bda7', component.options)
    }
    module.hot.accept("./incomeOld.vue?vue&type=template&id=52d8bda7", function () {
      api.rerender('52d8bda7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brokerManage/incomeOld.vue"
export default component.exports